var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _path7, _path8, _path9, _path10, _path11, _g6, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFreshtime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1031,
    height: 162,
    viewBox: "0 0 1031 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_281_1960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 119,
    height: 154
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.06505C0.779167 2.08505 77.864 2.12371 115.627 2.12371C116.401 2.12371 117.425 2.12371 118.166 2.12371C118.166 22.2837 118.426 42.4717 118.03 44.7877C94.7427 44.7877 71.4208 44.7877 48.0125 44.7877C48.0125 52.109 48.0125 59.233 48.0125 66.5344C67.5631 66.5344 87.1016 66.5344 106.581 66.5344C106.581 91.973 106.581 77.7104 106.581 104.658C101.718 104.757 97.0697 104.688 92.176 104.701C87.2531 104.713 82.3303 104.704 77.4068 104.704C72.5443 104.704 67.6812 104.704 62.8183 104.704C57.912 104.704 53.0068 104.704 47.964 104.704C47.964 121.792 47.964 138.702 47.964 155.872C47.1355 155.872 46.4396 155.872 45.7443 155.872C31.1557 155.872 0.659375 155.854 0 155.873C0 104.586 0 53.353 0 2.06505Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_281_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.06505C0.779167 2.08505 77.864 2.12371 115.627 2.12371C116.401 2.12371 117.425 2.12371 118.166 2.12371C118.166 22.2837 118.426 42.4717 118.03 44.7877C94.7427 44.7877 71.4208 44.7877 48.0125 44.7877C48.0125 52.109 48.0125 59.233 48.0125 66.5344C67.5631 66.5344 87.1016 66.5344 106.581 66.5344C106.581 91.973 106.581 77.7104 106.581 104.658C101.718 104.757 97.0697 104.688 92.176 104.701C87.2531 104.713 82.3303 104.704 77.4068 104.704C72.5443 104.704 67.6812 104.704 62.8183 104.704C57.912 104.704 53.0068 104.704 47.964 104.704C47.964 121.792 47.964 138.702 47.964 155.872C47.1355 155.872 46.4396 155.872 45.7443 155.872C31.1557 155.872 0.659375 155.854 0 155.873C0 104.586 0 53.353 0 2.06505Z",
    fill: "url(#paint0_linear_281_1960)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_281_1960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 467,
    y: 0,
    width: 121,
    height: 156
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M587.905 155.772C572.407 155.772 557.129 155.772 541.645 155.772C541.645 154.977 541.645 154.273 541.645 153.568C541.645 135.375 541.639 117.181 541.659 98.988C541.66 97.104 541.429 95.28 540.805 93.508C539.139 88.7746 534.808 85.5533 529.804 85.2493C523.364 84.8573 518.607 87.7213 515.057 92.868C514.647 93.4613 514.444 94.308 514.425 95.044C514.323 99.124 514.276 103.205 514.268 107.287C514.233 122.837 514.224 138.388 514.199 153.939C514.199 154.521 514.151 155.105 514.12 155.777C498.777 155.777 483.549 155.777 468.327 155.777C467.951 154.512 467.816 2.70398 468.199 -2.3267e-05C483.415 -2.3267e-05 498.644 -2.3267e-05 514.056 -2.3267e-05C514.056 19.1133 514.056 38.236 514.056 57.8347C514.728 57.172 515.092 56.844 515.42 56.4827C521.608 49.6947 529.197 45.3533 538.224 43.6827C556.504 40.3013 574.248 48.5973 582.952 65.236C586.327 71.6866 587.895 78.5907 587.9 85.848C587.916 108.425 587.905 131.003 587.905 153.579C587.905 154.284 587.905 154.988 587.905 155.772Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_281_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M587.905 155.772C572.407 155.772 557.129 155.772 541.645 155.772C541.645 154.977 541.645 154.273 541.645 153.568C541.645 135.375 541.639 117.181 541.659 98.988C541.66 97.104 541.429 95.28 540.805 93.508C539.139 88.7746 534.808 85.5533 529.804 85.2493C523.364 84.8573 518.607 87.7213 515.057 92.868C514.647 93.4613 514.444 94.308 514.425 95.044C514.323 99.124 514.276 103.205 514.268 107.287C514.233 122.837 514.224 138.388 514.199 153.939C514.199 154.521 514.151 155.105 514.12 155.777C498.777 155.777 483.549 155.777 468.327 155.777C467.951 154.512 467.816 2.70398 468.199 -2.3267e-05C483.415 -2.3267e-05 498.644 -2.3267e-05 514.056 -2.3267e-05C514.056 19.1133 514.056 38.236 514.056 57.8347C514.728 57.172 515.092 56.844 515.42 56.4827C521.608 49.6947 529.197 45.3533 538.224 43.6827C556.504 40.3013 574.248 48.5973 582.952 65.236C586.327 71.6866 587.895 78.5907 587.9 85.848C587.916 108.425 587.905 131.003 587.905 153.579C587.905 154.284 587.905 154.988 587.905 155.772Z",
    fill: "url(#paint1_linear_281_1960)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_281_1960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 224,
    y: 41,
    width: 120,
    height: 121
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.296 90.6612C302.601 81.4225 294.648 74.1665 284.725 74.4292C273.884 74.7172 268.828 83.9532 268.927 90.6612C280.051 90.6612 291.175 90.6612 302.296 90.6612ZM331.172 153.367C330.401 153.7 329.705 154.025 328.992 154.304C320.563 157.605 311.827 159.621 302.843 160.644C296.143 161.405 289.44 161.559 282.723 160.971C272.028 160.035 261.797 157.482 252.433 152.052C239.029 144.28 230.348 132.855 226.659 117.827C222.983 102.856 223.987 88.1399 230.388 74.0305C236.196 61.2292 245.836 52.2198 258.753 46.7385C268.197 42.7318 278.104 41.3318 288.308 41.6958C298.416 42.0558 308.032 44.3332 316.893 49.2798C329.741 56.4505 338.549 66.9225 342.44 81.2691C343.385 84.7571 343.804 88.3185 343.843 91.9438C343.909 98.2132 343.395 104.409 341.945 110.516C341.807 111.1 341.651 111.678 341.483 112.254C341.416 112.482 341.291 112.693 341.131 113.049C329.12 113.049 317.057 113.049 304.997 113.049C292.943 113.049 280.888 113.049 268.695 113.049C269.432 117.228 271.399 120.407 274.576 122.84C277.911 125.393 281.779 126.571 285.883 127.109C292.341 127.957 298.696 127.092 305.005 125.829C312.259 124.377 319.288 122.189 325.991 119.016C326.199 118.917 326.433 118.875 326.785 118.767C328.251 130.319 329.705 141.791 331.172 153.367Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_281_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.296 90.6612C302.601 81.4225 294.648 74.1665 284.725 74.4292C273.884 74.7172 268.828 83.9532 268.927 90.6612C280.051 90.6612 291.175 90.6612 302.296 90.6612ZM331.172 153.367C330.401 153.7 329.705 154.025 328.992 154.304C320.563 157.605 311.827 159.621 302.843 160.644C296.143 161.405 289.44 161.559 282.723 160.971C272.028 160.035 261.797 157.482 252.433 152.052C239.029 144.28 230.348 132.855 226.659 117.827C222.983 102.856 223.987 88.1399 230.388 74.0305C236.196 61.2292 245.836 52.2198 258.753 46.7385C268.197 42.7318 278.104 41.3318 288.308 41.6958C298.416 42.0558 308.032 44.3332 316.893 49.2798C329.741 56.4505 338.549 66.9225 342.44 81.2691C343.385 84.7571 343.804 88.3185 343.843 91.9438C343.909 98.2132 343.395 104.409 341.945 110.516C341.807 111.1 341.651 111.678 341.483 112.254C341.416 112.482 341.291 112.693 341.131 113.049C329.12 113.049 317.057 113.049 304.997 113.049C292.943 113.049 280.888 113.049 268.695 113.049C269.432 117.228 271.399 120.407 274.576 122.84C277.911 125.393 281.779 126.571 285.883 127.109C292.341 127.957 298.696 127.092 305.005 125.829C312.259 124.377 319.288 122.189 325.991 119.016C326.199 118.917 326.433 118.875 326.785 118.767C328.251 130.319 329.705 141.791 331.172 153.367Z",
    fill: "url(#paint2_linear_281_1960)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_281_1960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 354,
    y: 40,
    width: 101,
    height: 122
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M448.351 49.0508C446.872 60.5708 445.417 71.9175 443.957 83.2962C440.397 81.9135 437.031 80.5122 433.601 79.2922C427.035 76.9575 420.315 75.1669 413.396 74.2589C409.893 73.8002 406.351 73.3388 402.832 74.1268C401.864 74.3455 400.857 74.7361 400.064 75.3161C398.039 76.7975 397.941 79.4909 399.936 80.9895C401.307 82.0202 402.868 82.9015 404.477 83.4855C409.036 85.1442 413.657 86.6348 418.265 88.1548C424.077 90.0722 429.819 92.1602 435.213 95.0855C440.107 97.7388 444.564 100.944 448.043 105.372C451.965 110.363 453.869 116.056 454.025 122.368C454.215 129.979 452.347 136.984 447.788 143.16C443.961 148.347 438.935 152.081 433.176 154.855C426.632 158.008 419.684 159.737 412.497 160.656C400.743 162.159 389.151 160.96 377.621 158.682C370.675 157.31 363.836 155.515 357.18 153.075C356.567 152.851 355.961 152.603 355.192 152.304C356.724 140.554 358.247 128.86 359.791 117.011C360.239 117.174 360.568 117.256 360.865 117.406C370.692 122.339 381.027 125.721 391.903 127.332C395.927 127.929 399.995 128.509 404.084 127.863C405.02 127.715 405.971 127.462 406.831 127.071C409.305 125.948 410.289 122.371 407.417 120.531C405.915 119.568 404.311 118.682 402.639 118.08C397.733 116.315 392.764 114.731 387.833 113.038C381.528 110.874 375.361 108.396 369.725 104.761C365.961 102.333 362.605 99.4535 359.949 95.8202C355.277 89.4322 353.908 82.2015 354.763 74.4882C356.063 62.7548 362.504 54.4748 372.487 48.6988C379.007 44.9268 386.117 42.8508 393.524 41.7068C406.221 39.7455 418.757 40.9415 431.209 43.6721C436.015 44.7255 440.755 46.0202 445.348 47.8042C446.293 48.1708 447.221 48.5815 448.351 49.0508Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_281_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M448.351 49.0508C446.872 60.5708 445.417 71.9175 443.957 83.2962C440.397 81.9135 437.031 80.5122 433.601 79.2922C427.035 76.9575 420.315 75.1669 413.396 74.2589C409.893 73.8002 406.351 73.3388 402.832 74.1268C401.864 74.3455 400.857 74.7361 400.064 75.3161C398.039 76.7975 397.941 79.4909 399.936 80.9895C401.307 82.0202 402.868 82.9015 404.477 83.4855C409.036 85.1442 413.657 86.6348 418.265 88.1548C424.077 90.0722 429.819 92.1602 435.213 95.0855C440.107 97.7388 444.564 100.944 448.043 105.372C451.965 110.363 453.869 116.056 454.025 122.368C454.215 129.979 452.347 136.984 447.788 143.16C443.961 148.347 438.935 152.081 433.176 154.855C426.632 158.008 419.684 159.737 412.497 160.656C400.743 162.159 389.151 160.96 377.621 158.682C370.675 157.31 363.836 155.515 357.18 153.075C356.567 152.851 355.961 152.603 355.192 152.304C356.724 140.554 358.247 128.86 359.791 117.011C360.239 117.174 360.568 117.256 360.865 117.406C370.692 122.339 381.027 125.721 391.903 127.332C395.927 127.929 399.995 128.509 404.084 127.863C405.02 127.715 405.971 127.462 406.831 127.071C409.305 125.948 410.289 122.371 407.417 120.531C405.915 119.568 404.311 118.682 402.639 118.08C397.733 116.315 392.764 114.731 387.833 113.038C381.528 110.874 375.361 108.396 369.725 104.761C365.961 102.333 362.605 99.4535 359.949 95.8202C355.277 89.4322 353.908 82.2015 354.763 74.4882C356.063 62.7548 362.504 54.4748 372.487 48.6988C379.007 44.9268 386.117 42.8508 393.524 41.7068C406.221 39.7455 418.757 40.9415 431.209 43.6721C436.015 44.7255 440.755 46.0202 445.348 47.8042C446.293 48.1708 447.221 48.5815 448.351 49.0508Z",
    fill: "url(#paint3_linear_281_1960)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_281_1960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 43,
    width: 92,
    height: 113
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M222.151 45.8945C219.129 60.5639 216.148 75.0411 213.133 89.6798C212.587 89.4225 212.168 89.2425 211.765 89.0318C204.9 85.4478 197.717 84.2959 190.179 86.3865C185.025 87.8172 180.724 91.0745 177.543 95.8065C177.543 115.608 177.543 135.639 177.543 155.771C162.168 155.771 146.948 155.771 131.596 155.771C131.596 119.256 131.596 82.7825 131.596 46.2919C132.784 45.9572 171.003 45.8158 174.269 46.1678C174.692 51.3172 175.117 56.4985 175.584 62.1745C176.192 61.2011 176.579 60.5705 176.977 59.9478C181.316 53.1612 187.096 48.1012 194.779 45.4732C202.196 42.9358 209.772 42.2958 217.445 44.2465C218.993 44.6398 220.473 45.2985 222.151 45.8945Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_281_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.151 45.8945C219.129 60.5639 216.148 75.0411 213.133 89.6798C212.587 89.4225 212.168 89.2425 211.765 89.0318C204.9 85.4478 197.717 84.2959 190.179 86.3865C185.025 87.8172 180.724 91.0745 177.543 95.8065C177.543 115.608 177.543 135.639 177.543 155.771C162.168 155.771 146.948 155.771 131.596 155.771C131.596 119.256 131.596 82.7825 131.596 46.2919C132.784 45.9572 171.003 45.8158 174.269 46.1678C174.692 51.3172 175.117 56.4985 175.584 62.1745C176.192 61.2011 176.579 60.5705 176.977 59.9478C181.316 53.1612 187.096 48.1012 194.779 45.4732C202.196 42.9358 209.772 42.2958 217.445 44.2465C218.993 44.6398 220.473 45.2985 222.151 45.8945Z",
    fill: "url(#paint4_linear_281_1960)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M887.679 155.736C884.889 155.736 882.324 155.736 879.553 155.736C879.553 154.978 879.553 154.276 879.553 153.574C879.553 131.054 879.551 108.534 879.555 86.0136C879.556 80.503 878.845 75.111 876.649 70.015C871.979 59.167 863.811 52.6883 852.092 51.0416C843.321 49.8083 835.292 52.0803 828.093 57.175C819.229 63.4483 813.513 71.9617 810.563 82.3644C810.323 83.2097 810.32 84.143 810.32 85.035C810.309 107.855 810.311 130.676 810.311 153.496C810.311 154.203 810.311 154.911 810.311 155.707C807.643 155.707 805.144 155.707 802.444 155.707C802.424 155.02 802.385 154.326 802.385 153.632C802.381 130.752 802.415 107.871 802.364 84.991C802.348 77.7977 800.897 70.9137 797.027 64.7217C792.336 57.2203 785.561 52.7803 776.861 51.2817C766.492 49.4937 757.244 52.3123 748.867 58.339C742.192 63.1403 737.128 69.271 734.177 77.0336C733.319 79.2923 732.861 81.587 732.865 84.043C732.916 107.224 732.896 130.404 732.896 153.586C732.896 154.24 732.896 154.896 732.896 155.678C730.269 155.678 727.727 155.678 725.075 155.678C725.075 119.191 725.075 82.707 725.075 45.987C727.6 45.931 730.143 45.9603 732.829 45.9696C732.829 53.119 732.829 60.1217 732.829 67.123C732.915 67.1484 732.997 67.1724 733.081 67.1977C733.341 66.7804 733.619 66.3723 733.86 65.9443C740.789 53.6283 751.216 45.9817 765.085 43.5737C776.408 41.6083 786.941 44.0323 796.043 51.379C801.904 56.1097 805.743 62.2577 808.148 69.343C808.321 69.851 808.476 70.3683 808.743 71.2056C809.169 70.2963 809.471 69.627 809.796 68.971C815.515 57.439 824.1 48.911 836.489 44.9963C849.913 40.755 862.52 42.791 873.576 51.8136C880.776 57.6883 884.88 65.523 886.763 74.563C887.413 77.6883 887.684 80.8496 887.683 84.0416C887.676 107.162 887.679 130.283 887.679 153.403C887.679 154.116 887.679 154.83 887.679 155.736Z",
    fill: "#5CC7F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M922.459 97.6318C955.933 97.6318 989.167 97.6318 1022.5 97.6318C1022.52 97.2265 1022.58 96.8771 1022.54 96.5398C1022.13 92.7798 1021.56 89.0491 1020.47 85.4185C1016.54 72.4611 1008.87 62.5238 996.751 56.2505C989.195 52.3398 981.1 50.7264 972.616 50.7664C963.212 50.8118 954.453 53.1478 946.451 58.0678C933.793 65.8518 926.172 77.1758 923.253 91.6958C922.869 93.6078 922.728 95.5691 922.459 97.6318ZM1017.63 134.396C1018.55 137.005 1019.39 139.357 1020.28 141.862C1019.63 142.474 1019.02 143.112 1018.34 143.68C1011.55 149.405 1003.82 153.417 995.387 156.097C987.132 158.722 978.641 159.966 970 159.314C948.848 157.717 932.464 148.121 921.645 129.666C917.273 122.206 914.988 114.037 914.475 105.39C913.495 88.9305 918.475 74.4931 929.496 62.2678C938.785 51.9651 950.387 45.6971 964.144 43.6798C978.1 41.6345 991.319 43.9438 1003.43 51.3065C1017.65 59.9558 1026.1 72.7238 1029.47 88.9384C1030.41 93.4838 1030.69 98.0918 1030.56 102.726C1030.54 103.313 1030.46 103.897 1030.39 104.693C994.411 104.693 958.539 104.693 922.407 104.693C922.744 107.002 922.94 109.084 923.361 111.117C927.637 131.765 943.519 147.181 964.272 150.837C975.256 152.77 985.901 151.317 996.255 147.398C1004.07 144.441 1011.17 140.272 1017.63 134.396Z",
    fill: "#5CC7F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M619.176 155.74C616.227 155.74 613.603 155.74 610.804 155.74C610.804 107.26 610.804 58.8429 610.804 10.2749C591.561 10.2749 572.493 10.2749 553.3 10.2749C553.3 7.58288 553.3 5.03887 553.3 2.36687C594.284 2.36687 635.249 2.36687 676.309 2.36687C676.309 4.9682 676.309 7.51223 676.309 10.1936C657.271 10.1936 638.317 10.1936 619.176 10.1936C619.176 58.7482 619.176 107.166 619.176 155.74Z",
    fill: "#5CC7F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M690.396 38.4654C690.396 43.648 686.196 47.8494 681.013 47.8494C675.831 47.8494 671.629 43.648 671.629 38.4654C671.629 33.2827 675.831 29.0814 681.013 29.0814C686.196 29.0814 690.396 33.2827 690.396 38.4654Z",
    fill: "#5CC7F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M687.769 129.236V63.9892C687.769 60.1199 684.632 56.9825 680.763 56.9825C676.893 56.9825 673.755 60.1199 673.755 63.9892V71.6212V129.236C670.119 131.557 667.691 135.604 667.691 140.239C667.691 147.459 673.543 153.311 680.763 153.311C687.981 153.311 693.835 147.459 693.835 140.239C693.835 135.604 691.407 131.557 687.769 129.236Z",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_281_1960",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 671,
    y: 91,
    width: 20,
    height: 59
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M686.017 132.787V91.0243H675.508V132.787C673.017 134.474 671.379 137.326 671.379 140.562C671.379 145.743 675.58 149.944 680.763 149.944C685.945 149.944 690.145 145.743 690.145 140.562C690.145 137.326 688.508 134.474 686.017 132.787Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_281_1960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M686.017 132.787V91.0243H675.508V132.787C673.017 134.474 671.379 137.326 671.379 140.562C671.379 145.743 675.58 149.944 680.763 149.944C685.945 149.944 690.145 145.743 690.145 140.562C690.145 137.326 688.508 134.474 686.017 132.787Z",
    fill: "url(#paint5_linear_281_1960)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M686.017 90.9411C686.017 91.9384 683.664 92.7451 680.763 92.7451C677.861 92.7451 675.508 91.9384 675.508 90.9411C675.508 89.9451 677.861 89.1371 680.763 89.1371C683.664 89.1371 686.017 89.9451 686.017 90.9411Z",
    fill: "#EC1F26"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 67.4919H679.887",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 69.2439H677.384",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 71.6213H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 73.7827H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 75.8081H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 78.0679H679.887",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 79.8201H677.384",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 82.1973H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 84.3586H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 86.384H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 88.5879H679.887",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 90.3398H677.384",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 92.7173H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 94.8774H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 96.9023H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 98.9292H679.887",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 100.68H677.384",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 103.059H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 105.219H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 107.244H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 109.627H679.887",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 111.379H677.384",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 113.757H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 115.917H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 117.942H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 120.226H679.887",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 121.978H677.384",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 124.354H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 126.515H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M673.755 128.54H677.952",
    stroke: "#7A7D7D",
    strokeWidth: 0.666667,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_281_1960",
    x1: 2.66916,
    y1: 78.9691,
    x2: 587.34,
    y2: 78.9691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512376,
    stopColor: "#4FA9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_281_1960",
    x1: 2.66905,
    y1: 77.888,
    x2: 587.34,
    y2: 77.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512376,
    stopColor: "#4FA9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_281_1960",
    x1: 2.66909,
    y1: 101.485,
    x2: 587.34,
    y2: 101.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512376,
    stopColor: "#4FA9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_281_1960",
    x1: 2.66915,
    y1: 101.031,
    x2: 587.34,
    y2: 101.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512376,
    stopColor: "#4FA9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_281_1960",
    x1: 2.66924,
    y1: 99.4372,
    x2: 587.34,
    y2: 99.4372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3370C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512376,
    stopColor: "#4FA9E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3370C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_281_1960",
    x1: 680.763,
    y1: 149.944,
    x2: 680.763,
    y2: 91.0242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED1F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.80198,
    stopColor: "#ED1F26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A01C21"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFreshtime);
export default __webpack_public_path__ + "static/media/logo_freshtime.a3927ca19df155da6355e0b0c166b795.svg";
export { ForwardRef as ReactComponent };